<template>
  <div>
    <Card
      title="Artist Draft List"
    >
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search name" v-model="filter" @change="search" ></el-input>
              </div>
              <Button @clicked="search" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
            </div>
          </div>
        </div>
        <data-tables-server ref="tableArtist" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom" :width="title.prop.width">
          </el-table-column>
          <el-table-column v-if="isSuperAdmin || isAdmin || isOps" label="Actions" align="right" min-width="160px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Detail" :position="'is-left'">
                  <a :href="`/#/artists/detail/${scope.row.id}?fromDraft=1`"  class="inline-block p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </a>
                </VueCustomTooltip>
                <VueCustomTooltip label="Review And Publish" :position="'is-left'">
                  <a @click="detail(scope.row.id)"  class="inline-block p-2 w-8 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'check']" />
                  </a>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialogDetail
      :isShowingModal="isShowingModalReview"
      :isLoading="false"
      title="Review and Publish"
      @toggleModal="isShowingModalReview = !isShowingModalReview"
    >
      <template slot="body" >
        <div class="w-full">
          <ArtistProfile ref="artist-profile" @on-save="onSaveProfile" :is-reviewing="true" :user="getArtist" ></ArtistProfile>
        </div>
      </template>
    </ModalDialogDetail>
  </div>
</template>

<script>
import Vue from 'vue';
import ModalDialogDetail from '../../components/Common/ModalDialogDetail';
import ArtistProfile from './ArtistProfile';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import Card from '@/components/Layout/Card.vue';
import { Button } from '@/components/Layout/Form';

const limit = 20;
export default {
  name: 'ArtistDraft',
  data() {
    return {
      isError: false,
      isShowingModalReview: false,
      data: [],
      total: 0,
      page: 1,
      titles: [{
        prop: {
          field: 'name',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'email',
        },
        label: 'Email',
      }],
      filter: '',
      filterParam: {
        per_page: limit,
        q: '',
      },
    };
  },
  async mounted() {
    // this.toggleDashboardProfile(false);
    await this.requestListArtistDraft(this.filterParam);
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isFinance', 'isOps']),
    ...mapGetters('ArtistModule', ['listArtistDraft', 'getArtist']),
  },
  watch: {
    listArtistDraft: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('ArtistModule', ['requestListArtistDraft', 'requestDetailArtist']),
    async search() {
      this.filterParam.q = this.filter;
      await this.requestListArtistDraft(this.filterParam);
      // this.refineData();
    },
    async reset() {
      this.$refs.tableArtist.$refs.elTable.clearSort();
      this.filter = '';
      this.filterParam.q = '';
      this.search();
    },
    refineData() {
      if (this.listArtistDraft.data !== undefined) {
        this.total = this.listArtistDraft.data.total;
        this.data = this.listArtistDraft.data.data;
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filterParam = { ...this.filterParam, per_page: this.displayingItem, q: this.filter, sortorder, sortby, page };
      await this.requestListArtistDraft(this.filterParam);
    },
    async detail(id) {
      this.isShowingModalReview = true;
      await this.requestDetailArtist(id);
    },
    async onSaveProfile(state) {
      this.isShowingModalReview = false;
      this.$swal('Publish Artist', 'Publish Artist Success', 'success');
      await this.requestListArtistDraft(this.filterParam);
    },
  },
  components: { ModalDialogDetail, ArtistProfile,Card,
    Button, },
};
</script>

<style scoped>
.el-table{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/ArtistDraft.vue